import { inject, Injectable } from '@angular/core';
import { SchedulerWorkOrderApiService } from '../../../../common/scheduler/api/work-order.service';
import { ApiRouteInspectionService } from '../../../../api/elite/routes/inspection.service';
import { Observable } from 'rxjs';
import { Inspection } from '../../../../api/elite/types/inspections';
import { FilterDepartmentService } from '@dep/filters/services';
import { InspectionApiDto } from '../../../../api/elite/dto/inspection.dto';
import { ApiRouteInspectionMeasureService } from '../../../../api/elite/routes/inspection-measure.service';
import { InspectionMeasureApiDto } from '../../../../api/elite/dto/inspection-measure.dto';
import { ApiRouteSchedulerWorkOrderService } from '../../../../api/elite/routes/scheduling-work-order.service';
import { Stage } from '../../../../api/elite/types/stages';
import { ApiRouteFiltersService } from '../../../../api/elite/routes/filters.service';

@Injectable({
  providedIn: 'root',
})
export class FilterSchedulerWorkOrderService extends SchedulerWorkOrderApiService {
  protected readonly apiInspectionRouter = inject(ApiRouteInspectionService);
  protected readonly departmentService = inject(FilterDepartmentService);
  protected readonly inspectionMeasureService = inject(
    ApiRouteInspectionMeasureService
  );
  protected readonly workOrderService = inject(
    ApiRouteSchedulerWorkOrderService
  );
  protected readonly apiFiltersService = inject(ApiRouteFiltersService);

  // checkForOpenInspection(workOrderId: number): Observable<Inspection> {
  //   return this.apiInspectionRouter.checkForOpenInspection(workOrderId);
  // }

  validateInspectionShift(
    workOrderId: number,
    machineId: number
  ): Observable<{ openInspection: Inspection; measureStage: Stage }> {
    return this.apiInspectionRouter.validateInspectionByShift({
      workOrderId,
      machineId,
    });
  }

  setItemStage(data: {
    workOrderId: number;
    machineId: number;
    stage: string;
  }): Observable<{ stages: Stage[] }> {
    return this.workOrderService.setItemStage(data);
  }

  approveOrder(data: {
    workOrderId: number;
    machineId: number;
    status: 'approved' | 'rejected';
  }): Observable<any> {
    return this.apiFiltersService.approveWorkOrder(data);
  }

  finishPartial(
    inspectionId: number,
    body?: InspectionMeasureApiDto['finishPartial']['body']
  ): Observable<any> {
    return this.inspectionMeasureService.finishPartial(inspectionId, body);
  }

  finishInspection(
    inspectionId: number,
    notes?: string,
    body?: InspectionApiDto['finish']['body']
  ): Observable<InspectionApiDto['finish']['result']> {
    return this.apiInspectionRouter.finishInspection(inspectionId, notes, body);
  }
}
